export type Release = {
  date: string;
  tag?: string;
  version?: string;
  title: string;
  description: string;
  highlights?: string[];
  fixes?: string[];
};

// Newest first. Versions track the mobile app's marketing version.
export const RELEASES: Release[] = [
  {
    date: '03/07/2026',
    version: '1.0.5',
    tag: 'Clubs & payments',
    title: 'Paid clubs, club chat & sharing',
    description:
      "Our biggest update yet, built around clubs. Run a paid community, give members early access, and share what's on straight into your chats.",
    highlights: [
      'Paid club memberships — one-time or monthly, powered by Stripe',
      'Members-only clubs with a locked preview so everyone can see what they\'re missing',
      'Early access to events for club members',
      'A dedicated chat for every club',
      'Share any event straight into your in-app chats',
      'Redesigned event details and “you\'re going” screens',
    ],
    fixes: [
      'Smoother checkout as a bottom sheet with Apple Pay & Google Pay',
      'Pause and resume a club subscription any time',
      'Organizers can now get paid across more countries',
    ],
  },
  {
    date: '18/06/2026',
    version: '1.0.4',
    tag: 'Home & messaging',
    title: 'A cleaner home, more to do, real messaging',
    description:
      'We reworked the home screen, added a lot more to discover, and gave you proper messaging.',
    highlights: [
      'Home split into Events and Clubs tabs',
      '98 activities across 15 categories to tag your events',
      'Searchable, animated activity picker',
      'Direct messages between members',
      'Reply to messages inside event chats',
      'New Connections bar and screens to keep up with your people',
    ],
    fixes: [
      'Fresh splash screen and a refreshed tab bar (including iOS 26)',
      'Calendar moved into the header, with swipe-to-pick dates on the map',
      'Pull-to-refresh on home and fixed like counts on new posts',
    ],
  },
  {
    date: '05/06/2026',
    version: '1.0.3',
    tag: 'Widgets & imports',
    title: 'Home-screen widgets, Eventbrite & liquid glass',
    description:
      'Bring your week to your home screen, import events you already run, and enjoy a glassier look throughout.',
    highlights: [
      'Home-screen widgets on iOS and Android',
      'Import events straight from Eventbrite',
      'New liquid-glass menu and UI polish',
      'Admin tools for managing content and covers',
    ],
    fixes: [
      'Calendar and “add socials” screens cleaned up',
      'Android map, tabs and navigation fixes',
      'Performance and stability optimizations',
    ],
  },
  {
    date: '14/05/2026',
    version: '1.0.2',
    tag: 'Stability',
    title: 'Stability & polish',
    description:
      'A stabilization update focused on smoothing out the early experience.',
    fixes: [
      'Android stability improvements across the app',
      'Language switching fixes',
      'Create-club validation and clearer terms consent before you create an account or event',
    ],
  },
  {
    date: '27/04/2026',
    version: '1.0.0',
    tag: 'App release',
    title: 'Gather is live',
    description:
      "The first public release of Gather. Find what's on this week, host your own meetup, and meet the people who keep showing up.",
    highlights: [
      'Sign in with Apple, Google, or email + one-time code',
      'Discover nearby events with a personalized feed',
      'Host an event in under 60 seconds',
      'Join clubs around shared interests (rooftops, vinyl, padel, ceramics)',
      'In-app chat for events and clubs',
    ],
  },
];
